export class SolarConfigModel {
    constructor(
        public siteId?: string,
        public noOfInvertors?: number,
        public processNameAndCapacity?: any,
        public processNameRids?: any,
        public noOfClusters?: number,
        public totalInstalledCapacity?: number
        ) {
            this.siteId = null;
            this.noOfInvertors = null;
            this.processNameAndCapacity = null;
            this.processNameRids = null;
            this.noOfClusters = null;
            this.totalInstalledCapacity = null;
    }
}
export class SolarParametersModel {
    constructor(
        public siteId?: string,
        public processNameRids?: any,
        public dateSelected?: string,
        public parameters?: any,
        ) {
    }
}

export class PowerAndIrradianceTrendParametersModel {
    constructor(
        public siteId?: string,
        public processNameRids?: any,
        public dateSelected?: string,
        ) {
    }
}
export class SolarLongTermTrendParameterModel {
    constructor(
        public siteId?: string,
        public fromDate?: string,
        public toDate?: string,
        public timebase?: any,
        public enableShiftwise?: any,
        public meterIds?: any
        ) {
    }
}
